import type {
  SeoCatalogItem,
  SeoEntryPayload,
  SeoEntryResponse,
  SeoEntityType,
  SeoGlobalConfig,
  SeoResolved,
} from '@/lib/seo';
import { apiGet, apiPut } from './api-client';

export async function fetchSeoGlobal(): Promise<SeoGlobalConfig> {
  const res = await apiGet<{ data: SeoGlobalConfig }>('/admin/seo/global', true);
  return res.data;
}

export async function updateSeoGlobal(payload: Partial<SeoGlobalConfig>): Promise<SeoGlobalConfig> {
  const res = await apiPut<{ data: SeoGlobalConfig }>('/admin/seo/global', payload, true);
  return res.data;
}

export async function fetchSeoCatalog(type: string = 'all', q: string = ''): Promise<SeoCatalogItem[]> {
  const params = new URLSearchParams();
  if (type && type !== 'all') params.set('type', type);
  if (q.trim()) params.set('q', q.trim());
  const qs = params.toString();
  const res = await apiGet<{ data: SeoCatalogItem[] }>(
    `/admin/seo/catalog${qs ? `?${qs}` : ''}`,
    true
  );
  return res.data ?? [];
}

export async function fetchSeoPages(): Promise<Array<{ key: string; label: string; path: string }>> {
  const res = await apiGet<{ data: Array<{ key: string; label: string; path: string }> }>(
    '/admin/seo/pages',
    true
  );
  return res.data ?? [];
}

export async function fetchSeoEntry(opts: {
  entityType: SeoEntityType;
  entityId?: number | null;
  pageKey?: string | null;
}): Promise<SeoEntryResponse> {
  const params = new URLSearchParams();
  params.set('entityType', opts.entityType);
  if (opts.entityId != null) params.set('entityId', String(opts.entityId));
  if (opts.pageKey) params.set('pageKey', opts.pageKey);
  const res = await apiGet<{ data: SeoEntryResponse }>(`/admin/seo/entry?${params}`, true);
  return res.data;
}

export async function upsertSeoEntry(payload: SeoEntryPayload): Promise<SeoEntryResponse> {
  const res = await apiPut<{ data: SeoEntryResponse }>('/admin/seo/entry', payload, true);
  return res.data;
}

export async function resolvePublicSeo(path: string): Promise<SeoResolved | null> {
  try {
    const params = new URLSearchParams({ path });
    const res = await apiGet<{ data: SeoResolved }>(`/seo/resolve?${params}`);
    return res.data ?? null;
  } catch {
    return null;
  }
}
